import { render, staticRenderFns } from "./o-awards.vue?vue&type=template&id=0eef134e"
import script from "./o-awards.vue?vue&type=script&lang=js"
export * from "./o-awards.vue?vue&type=script&lang=js"
import style0 from "./o-awards.vue?vue&type=style&index=0&id=0eef134e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports